import AdvancedSearchM from '../model/recordm.model.advancedsearch.js';
import BulkRequestM from '../model/recordm.model.bulkrequest.js';
import { ConfirmDialog } from '@cob/ui-genesis/helpers/cob.dialog.js';
import { DEV_MODE } from '@cob/ui-genesis/helpers/cob.devmode.js';
import SimpleSearchM from '../model/recordm.model.simplesearch.js';

import { format as formatNumber } from '../fields/recordm.fields.number.js';
import { sprintf } from 'sprintf-js';

var BulkDelete = function(core) {

    var _pushRequest = function(req) {
        new BulkRequestM(core).deleteInstances(
            req.definitionId,
            req.query,
            req.ids
        );
    };

    var _confirmDelete = function(totalAffected, onConfirmCb, onCancelCb) {
        var message = sprintf(
            core.translateString("recordm.instances", "msgs.bulk-delete-msg"),
            formatNumber(totalAffected, false, 0, core.getLocale())
        );

        ConfirmDialog(core, {
                message: message,
                confirmBtnLabel: core.translateString("recordm.instances", "action.delete"),
                confirmBtnClass: "btn-danger"
            },
            {
                requestConfirmed: onConfirmCb,
                requestCanceled: onCancelCb
            }
        );
    };

    var _getSearchModel = function(req) {
        var definitionId = req.definitionId,
            isAdvSearch = false,
            advQuery;

        try {
            advQuery = JSON.parse(req.query);

            // JSON.parse(10) returns 10 and will not throw any exception
            isAdvSearch = (typeof advQuery === 'object');

        } catch (e) {
            DEV_MODE && window.console.log("INFO: Conversion to json failed so I will handle it has a query string", req.query);
        }

        if (isAdvSearch) {
            return new AdvancedSearchM(core,
                "recordm/definitions/search/advanced/" + definitionId
            );
        } else {
            return new SimpleSearchM(
                core,
                "recordm/definitions/search/" + definitionId
            );
        }
    };

    var _execute = function(req) {
        var searchM,
            isAdvQuery;

        if (req.query) {
            searchM = _getSearchModel(req);
            isAdvQuery = (searchM instanceof AdvancedSearchM);

            searchM.setRowsPerPage(0);
            searchM.setCurrentQuery(isAdvQuery ? JSON.parse(req.query) : req.query);
            searchM._executeSearch({onSearchDone: function() {
                _confirmDelete(searchM.getTotalMatchingResults(),
                    function() {
                        // if it is a advance query then I need to
                        // build the query for search and overwrite the current query
                        // from the request
                        if (isAdvQuery) {
                            req.query = AdvancedSearchM._buildSearchQuery(JSON.parse(req.query));
                        }

                        _pushRequest(req);
                    }
                );
            }});
        } else {
            _confirmDelete(req.ids.length,
                function() {
                    _pushRequest(req);
                }
            );
        }

    };

    return {
        execute: _execute
    }
};

export default BulkDelete;
